<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.products'), $t('text.list')]">
        <span v-if="Permit.canActions('productManage')">
          <el-button
            type="success"
            size="mini"
            @click="$router.push('/normal/pdm/products/new')"
            >+ {{ $t("text.create") }}</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="$router.push('/normal/pdm/products/new-import')"
            >{{ $t("action.import") }}</el-button
          >

          <el-button
            v-if="
              Permit.extendModels().includes('mms') &&
              Permit.canActionsChargeEdition('mmsProductIngredient')
            "
            type="default"
            size="mini"
            @click="$router.push('/normal/pdm/products/new-import-materials')"
            >{{ $t("action.importIngredient") }}</el-button
          >
          <el-button
            v-if="
              Permit.extendModels().includes('mes') &&
              Permit.canActionsChargeEdition('mesProductDistributePhases')
            "
            type="default"
            size="mini"
            @click="$router.push('/normal/pdm/products/new-import-phases')"
            >{{ $t("action.importPhases") }}</el-button
          >
        </span>
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.supplierProductNo"
            :placeholder="$t('product.supplierProductNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.labels"
            filterable
            multiple
            :placeholder="$t('menu.labels')"
          >
            <el-option
              v-for="label in labels"
              :key="label.id"
              :label="label.name"
              :value="label.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="Permit.extendModels().includes('mms')">
          <el-select
            size="small"
            v-model="searchForm.materialId"
            filterable
            remote
            :remote-method="querySearchSerialNo"
            :loading="serialNosLoading"
            :clearable="true"
            :placeholder="$t('material.serialNoName')"
          >
            <el-option
              v-for="material in materials"
              :key="material.id"
              :label="material.serialNoName"
              :value="material.id"
              :style="
                material.suppliersNoStr == '' ? '' : 'height: 55px !important'
              "
            >
              <div>
                <div>{{ material.serialNoName }}</div>
                <div class="suppliersNoStr">
                  {{ material.suppliersNoStr }}
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar
          ref="recordsToolbar"
          :custom="!cardPattern"
          zoom
          class="table-toolbar"
        >
          <template v-slot:buttons>
            <el-checkbox
              v-if="cardPattern"
              v-model="checkAllDF"
              value="1"
              style="margin-right: 10px"
              @change="checkAll"
              >{{ $t("action.checkAll") }}</el-checkbox
            >

            <el-button
              v-if="Permit.canActions('inquiryInquiriesManage')"
              type="warning"
              size="mini"
              @click="inquiry('', 'batch')"
              >{{ $t("action.inquiry") }}</el-button
            >

            <el-button
              v-if="Permit.canActions('productVerify')"
              type="primary"
              size="mini"
              :loading="verifyBatchDoing"
              @click="verifyBatch"
              >{{ $t("action.verify") }}</el-button
            >
            <el-button
              v-if="Permit.canActions('productManage')"
              type="success"
              size="mini"
              @click="batchAddLabel"
              >+ {{ $t("menu.labels") }}</el-button
            >
            <el-button
              v-if="Permit.canActions('productManage')"
              type="danger"
              size="mini"
              @click="batchDelete"
              >{{ $t("text.delete") }}</el-button
            >

            <el-dropdown
              v-if="Permit.canActions('productManage')"
              class="mgl10"
              @command="batchUpdateSupplierPriceToCost"
            >
              <el-button type="primary" size="mini">
                {{ $t("action.updateSupplierPriceToCostSimple") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.updateChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.updateSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown class="mgl10" @command="printTag">
              <el-button type="default" size="mini">
                {{ $t("action.printTag") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printQrCodesDiv"
                  >有售价</el-dropdown-item
                >
                <el-dropdown-item command="printQrCodesNoPriceDiv"
                  >无售价</el-dropdown-item
                >
                <el-dropdown-item command="printSelectColorSizeDiv"
                  >选颜色规格</el-dropdown-item
                >
                <el-dropdown-item
                  v-for="(pt, index) of printTemplatesProduct"
                  :divided="index == 0 ? true : false"
                  :key="index"
                  :command="pt"
                  >{{ pt.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              class="mgl10"
              type="default"
              size="mini"
              @click="printBaseInfo"
              >{{ $t("action.printBaseInfo") }}</el-button
            >

            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
                <el-dropdown-item command="checkedWithImg">{{
                  $t("action.downLoadCheckedWithImg")
                }}</el-dropdown-item>
                <el-dropdown-item command="searchWithImg">{{
                  $t("action.downLoadSearchWithImg")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown
              class="mgl10"
              @command="downloadPhases"
              v-if="
                Permit.extendModels().includes('mes') &&
                (Permit.canActionsChargeEdition('mesProductView') ||
                  Permit.canActionsChargeEdition('globalCostPrice'))
              "
            >
              <el-button type="default" size="mini">
                {{ $t("action.download") }}{{ $t("menu.phases") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-switch
              v-model="cardPattern"
              class="float-right"
              active-color="#ff4949"
              inactive-color="#13ce66"
              active-text="卡片模式"
              inactive-text="列表模式"
              @change="cardPatternChange"
            ></el-switch>
          </template>
        </vxe-toolbar>
      </sticky>
      <div v-if="cardPattern" :loading="loading">
        <div v-if="records && records.length != 0">
          <el-row :gutter="5">
            <el-col
              v-for="(row, rowIndex) in records"
              :key="row.id"
              :span="4"
              class="mgt10"
            >
              <el-card :body-style="{ padding: '0px' }">
                <div style="height: 280px">
                  <div class="image-div">
                    <div class="product-checkbox-div" style="z-index: 2">
                      <input
                        v-model="checkedProducts"
                        type="checkbox"
                        :value="row"
                        class="float-right"
                        @change="checkedProduct"
                      />
                    </div>
                    <div
                      v-if="row.productLabels.length != 0"
                      class="product-label-div"
                      style="z-index: 2"
                    >
                      <span
                        v-for="productLabel in row.productLabels.slice(0, 6)"
                        :key="productLabel.id"
                        class="float-left product-label"
                      >
                        <raw-html-limit-number
                          :content="productLabel.name"
                          :number="5"
                        />
                      </span>

                      <span
                        v-if="row.productLabels.length > 6"
                        class="float-left product-label"
                      >
                        ...
                      </span>
                    </div>
                    <thumbnail :images="row.images" width="100%" height="200" />
                  </div>
                  <div class="pd5">
                    <el-row class="mgb5">
                      <el-col :span="20" class="overflow">
                        <span v-if="row.verifyAt != null" class="green font10">
                          ({{ $t("product.verify") }})
                        </span>
                        <span class="blue" @click="showRow(row, rowIndex)">
                          {{ row.productNo }}
                        </span>
                      </el-col>
                      <el-col
                        v-if="
                          row.verifyAt != null &&
                          Permit.canActions('inquiryInquiriesManage')
                        "
                        :span="4"
                        class="overflow"
                      >
                        <div
                          type="text"
                          class="right button font12"
                          @click="inquiry(row, 'single')"
                        >
                          {{ $t("action.inquiry") }}
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12" class="overflow">
                        <div style="min-height: 21px">
                          {{ row.categoryName }}
                        </div>
                      </el-col>
                      <el-col
                        v-if="Permit.canActions('globalSalePrice')"
                        :span="12"
                        class="overflow right red"
                      >
                        <currency
                          :code="row.salesCurrency"
                          v-if="row.salesPrice != null"
                        ></currency
                        >{{ row.salesPrice }}</el-col
                      >
                    </el-row>
                    <el-row>
                      <el-col
                        v-if="
                          Permit.canActions('productManage') ||
                          Permit.canActions('productDelete')
                        "
                        :span="14"
                      >
                        <span style="height: 28px; line-height: 28px">
                          <span
                            v-if="Permit.canActions('productManage')"
                            class="blue font10 mgr8"
                            @click="editRow(row, rowIndex)"
                            >{{ $t("text.edit") }}</span
                          >
                          <span
                            v-if="Permit.canActions('productDelete')"
                            class="blue font10 mgr8"
                            @click="deleteRow(row)"
                            >{{ $t("text.delete") }}</span
                          >
                          <span
                            class="blue font10"
                            v-if="Permit.canActions('productManage')"
                            @click="refreshRow(row)"
                            >{{ $t("action.refresh") }}</span
                          >
                        </span>
                      </el-col>
                      <el-col :span="10" class="right">
                        <span
                          v-if="
                            Permit.extendModels().includes('mms') &&
                            (Permit.canActionsChargeEdition('mmsProductView') ||
                              Permit.canActionsChargeEdition('globalCostPrice'))
                          "
                          class="mgr5"
                        >
                          <el-button
                            type="text"
                            size="mini"
                            :class="
                              row.mixState == 'mixed'
                                ? 'green'
                                : row.mixState == 'mixing'
                                ? 'orange'
                                : ''
                            "
                            @click="showMaterial(row, rowIndex)"
                            >{{
                              $t("productMixStates." + row.mixState)
                            }}</el-button
                          >
                        </span>
                        <el-button
                          v-if="
                            Permit.extendModels().includes('mes') &&
                            (Permit.canActionsChargeEdition('mesProductView') ||
                              Permit.canActionsChargeEdition('globalCostPrice'))
                          "
                          type="text"
                          size="mini"
                          :class="row.matchAt != null ? 'green' : ''"
                          @click="showPhase(row)"
                          >{{ $t("product.phase") }}</el-button
                        >
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div v-else class="noData">{{ $t("text.noData") }}</div>
      </div>
      <div v-else>
        <vxe-table
          :data="records"
          @checkbox-change="setSelected"
          @checkbox-all="setSelected"
          :checkbox-config="{ reserve: true }"
          :loading="loading"
          id="productsTable"
          row-id="id"
          ref="recordsTable"
          class="recordsTable"
          size="mini"
          resizable
          round
          highlight-hover-row
          auto-resize
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="checkbox"
            type="checkbox"
            width="35"
          ></vxe-table-column>
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="80"
          >
            <template v-slot="{ row }">
              <thumbnail :images="row.images" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            width="150"
            sortable
          >
            <template v-slot="{ row, rowIndex }">
              <span v-if="row.verifyAt != null" class="green font10"
                >({{ $t("product.verify") }})</span
              >
              <span class="blue" @click="showRow(row, rowIndex)">{{
                row.productNo
              }}</span>
              <div v-if="row.productNoAlias != null" class="font10">
                {{ $t("product.alias") }}: {{ row.productNoAlias }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="categoryName"
            :title="$t('product.category')"
            width="100"
          />
          <vxe-table-column
            v-if="Permit.canActions('globalSalePrice')"
            field="salesPrice"
            :title="$t('product.salesPrice')"
            width="100"
          >
            <template v-slot="{ row }">
              <currency
                :code="row.salesCurrency"
                v-if="row.salesPrice != null"
              ></currency
              >{{ row.salesPrice }}</template
            >
          </vxe-table-column>
          <vxe-table-column
            v-if="Permit.canActions('globalSalePrice')"
            field="wholesalePrice"
            :title="$t('product.wholeSalePrice')"
            width="100"
          >
            <template v-slot="{ row }">
              {{ row.wholesalePrice | currency }}</template
            >
          </vxe-table-column>
          <vxe-table-column field="colors" :title="$t('product.color')">
            <template v-slot="{ row }">{{ row.colors.join("，") }}</template>
          </vxe-table-column>
          <vxe-table-column field="sizes" :title="$t('product.size')">
            <template v-slot="{ row }">{{ row.sizes.join("，") }}</template>
          </vxe-table-column>
          <vxe-table-column field="productLabels" :title="$t('product.label')">
            <template v-slot="{ row }">{{
              row.productLabels.map((l) => l.name).join("，")
            }}</template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="130"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button
                v-if="Permit.canActions('productManage')"
                size="mini"
                type="text"
                @click="editRow(row, rowIndex)"
                >{{ $t("text.edit") }}</el-button
              >
              <el-button
                v-if="Permit.canActions('productDelete')"
                type="text"
                size="mini"
                @click="deleteRow(row)"
                >{{ $t("text.delete") }}</el-button
              >
              <el-button
                v-if="Permit.canActions('productManage')"
                type="text"
                size="mini"
                @click="refreshRow(row)"
                >{{ $t("action.refresh") }}</el-button
              >
              <div>
                <el-button
                  v-if="
                    row.verifyAt != null &&
                    Permit.canActions('inquiryInquiriesManage')
                  "
                  type="text"
                  size="mini"
                  @click="inquiry(row, 'single')"
                  >{{ $t("action.inquiry") }}</el-button
                >
                <el-button
                  v-if="
                    Permit.extendModels().includes('mes') &&
                    (Permit.canActionsChargeEdition('mesProductView') ||
                      Permit.canActionsChargeEdition('globalCostPrice'))
                  "
                  type="text"
                  size="mini"
                  :class="row.matchAt != null ? 'green' : ''"
                  @click="showPhase(row)"
                  >{{ $t("product.phase") }}</el-button
                >
                <el-button
                  v-if="
                    Permit.extendModels().includes('mms') &&
                    (Permit.canActionsChargeEdition('mmsProductView') ||
                      Permit.canActionsChargeEdition('globalCostPrice'))
                  "
                  type="text"
                  size="mini"
                  :class="
                    row.mixState == 'mixed'
                      ? 'green'
                      : row.mixState == 'mixing'
                      ? 'orange'
                      : ''
                  "
                  @click="showMaterial(row, rowIndex)"
                  >{{ $t("productMixStates." + row.mixState) }}</el-button
                >
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 询价 -->
    <el-dialog
      :title="$t('action.inquiry')"
      :close-on-click-modal="false"
      :visible.sync="inquiryDF"
      width="40%"
    >
      <el-form ref="inquiryObjForm" :model="inquiryObj" label-width="80px">
        <el-form-item :label="$t('inquiry.type')" :prop="'type'">
          <el-radio-group size="small" v-model="inquiryObj.type">
            <el-radio label="private">{{
              $t("inquiryTypes.private")
            }}</el-radio>
            <el-radio label="public">{{ $t("inquiryTypes.public") }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-row v-if="inquiryType == 'single'">
          <el-col :span="10">
            <el-form-item
              :label="$t('text.quantity')"
              :prop="'quantity'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.quantity')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="inquiryObj.quantity" />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item
              :label="$t('inquiry.expirateAt')"
              :prop="'expirateAt'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('inquiry.expirateAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="inquiryObj.expirateAt"
                type="date"
                :picker-options="pickerTodayAfterTime"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          v-if="inquiryType == 'batch'"
          :label="$t('inquiry.expirateAt')"
          :prop="'expirateAt'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('inquiry.expirateAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            size="small"
            v-model="inquiryObj.expirateAt"
            type="date"
            :picker-options="pickerTodayAfterTime"
          />
        </el-form-item>
        <el-form-item :label="$t('text.explain')" :prop="'explain'">
          <el-input
            size="small"
            v-model.trim="inquiryObj.explain"
            type="textarea"
          />
        </el-form-item>
        <div v-if="inquiryObj.type == 'private'">
          <el-form-item
            :label="$t('menu.suppliers')"
            :prop="'explain'"
            style="line-height: 20px"
          >
            <el-checkbox
              size="small"
              v-model="checkAllSuppliersDF"
              :indeterminate="isIndeterminateSuppliersDF"
              @change="checkAllSuppliers"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
            <el-checkbox-group
              size="small"
              v-model="checkedSuppliers"
              @change="checkSupplier"
            >
              <el-checkbox
                style="width: 80px"
                v-for="supplier in inquirySuppliers"
                :key="supplier.id"
                :label="supplier"
                >{{ Util.limitText(supplier.name, 5) }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="inquirySubmitDoing"
          size="small"
          @click="inquirySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="inquiryDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 标签 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="batchAddLabelDF"
      width="50%"
    >
      <el-form ref="batchAddLabelObjForm" label-width="80px">
        <el-row>
          <span
            v-for="(labelGroup, labelGroupIndex) of labelGroups"
            :key="labelGroupIndex"
          >
            <el-col :span="12" v-if="labelGroup.name != '--'">
              <el-form-item :label="labelGroup.name" :prop="'radio'">
                <el-select
                  size="small"
                  v-model="labelGroup.radio"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="label in labelGroup.labels"
                    :key="label.id"
                    :label="label.name"
                    :value="label.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="labelGroup.name == '--'">
              <el-checkbox-group size="small" v-model="labelGroup.radio">
                <el-checkbox
                  v-for="label in labelGroup.labels"
                  :key="label.id"
                  :label="label.id"
                  style="width: 120px"
                >
                  <raw-html-limit-number :content="label.name" :number="8" />
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </span>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="batchAddLabelSubmitDoing"
          size="small"
          @click="batchAddLabelSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="batchAddLabelDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <div id="printQrCodesDiv" style="display: none">
      <div
        v-for="(cp, index) in checkedProducts"
        :key="cp.id"
        :style="
          'margin:0 auto 10px; width:200px; text-align:left; font-size: 14px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div>
          <!-- :value="qrCodes(cp)" -->
          <qrcode
            :value="`${cp.productNo}`"
            :options="{ width: 100 }"
            :tag="'img'"
          />
        </div>
        <div style="padding-left: 10px">
          <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
          <div>{{ $t("product.category") }}：{{ cp.categoryName }}</div>
          <div>
            {{ $t("product.salesPrice") }}：
            <currency
              :code="cp.salesCurrency"
              v-if="cp.salesPrice != null"
            ></currency
            >{{ cp.salesPrice }}
          </div>
        </div>
      </div>
    </div>
    <div id="printQrCodesNoPriceDiv" style="display: none">
      <div
        v-for="(cp, index) in checkedProducts"
        :key="cp.id"
        :style="
          'margin:0 auto 10px; width:200px; text-align:left; font-size: 14px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div>
          <!-- :value="qrCodes(cp)"  -->
          <qrcode
            :value="`${cp.productNo}`"
            :options="{ width: 100 }"
            :tag="'img'"
          />
        </div>
        <div style="padding-left: 10px">
          <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
          <div>{{ $t("product.category") }}：{{ cp.categoryName }}</div>
        </div>
      </div>
    </div>

    <div id="printSelectColorSizeDiv" style="display: none">
      <div
        v-for="(cp, index) in combinationProducts"
        :key="index"
        :style="
          'margin:0 auto; width:400px; text-align:left; font-size: 18px;word-break: break-all;word-wrap: break-word' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div style="clear: both">
          <div style="float: left; width: 100px">
            <qrcode
              :value="`${cp.productNo}|${cp.color}|${cp.size}|product|`"
              :options="{ width: 100 }"
              :tag="'img'"
            />
          </div>
          <div
            style="
              float: left;
              width: 260px;
              word-break: break-all;
              word-wrap: break-word;
            "
          >
            <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
            <div v-if="cp.categoryName != null">
              {{ $t("product.category") }}：{{ cp.categoryName }}
            </div>
            <div v-if="cp.color != null">
              {{ $t("product.color") }}：{{ cp.color }}
            </div>
            <div v-if="cp.size != null">
              {{ $t("product.size") }}：{{ cp.size }}
            </div>
            <div>{{ $t("product.salesPrice") }}：¥ {{ cp.salesPrice }}</div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div id="printSelectColorSizeDivNoPrice" style="display: none">
      <div
        v-for="(cp, index) in combinationProducts"
        :key="index"
        :style="
          'margin:0 auto; width:400px; text-align:left; font-size: 14px;word-break: break-all;word-wrap: break-word' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div style="display: flex">
          <div>
            <qrcode
              :value="`${cp.productNo}|${cp.color}|${cp.size}|product|`"
              :options="{ width: 100 }"
              :tag="'img'"
            />
          </div>
          <div
            style="
              margin-top: 8px;
              word-break: break-all;
              word-wrap: break-word;
            "
          >
            <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
            <div v-if="cp.categoryName != null">
              {{ $t("product.category") }}：{{ cp.categoryName }}
            </div>
            <div v-if="cp.color != null">
              {{ $t("product.color") }}：{{ cp.color }}
            </div>
            <div v-if="cp.size != null">
              {{ $t("product.size") }}：{{ cp.size }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="printCustomTemplateDiv" style="display: none">
      <div id="printCustomTemplate" />
    </div>
    <div id="printBaseInfoDiv" style="display: none">
      <div
        v-for="(cp, index) in checkedProducts"
        :key="index"
        :style="
          'margin:0 auto; width:600px; text-align:left; font-size: 18px;word-break: break-all;word-wrap: break-word' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr>
            <td
              colspan="4"
              style="
                border: 1px solid #dfe5ec;
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                height: 40px;
              "
            >
              {{ cp.productNo }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.category") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cp.categoryName }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.brand") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cp.brand }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.productNoAlias") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cp.productNoAlias }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.unit") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cp.unit }}
            </td>
          </tr>
          <tr>
            <td colspan="4" style="border: 1px solid #dfe5ec">
              <img
                v-if="Util.tranStringToArr(cp.images)[0]"
                style="
                  max-width: 280px;
                  max-height: 400px;
                  vertical-align: top;
                  margin-right: 5px;
                "
                :src="Util.tranStringToArr(cp.images)[0]"
              />
              <img
                v-if="Util.tranStringToArr(cp.images)[1]"
                style="max-width: 280px; max-height: 400px; vertical-align: top"
                :src="Util.tranStringToArr(cp.images)[1]"
              />
            </td>
          </tr>
          <tr>
            <td colspan="4" style="border: 1px solid #dfe5ec">
              <div
                v-for="(im, imIndex) in Util.tranStringToArr(cp.images)"
                :key="imIndex"
                style="float: left"
              >
                <img
                  v-if="![0, 1].includes(imIndex)"
                  :src="im"
                  width="80"
                  style="width: 80px; margin-right: 5px; vertical-align: top"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.craftwork") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              <raw-html :content="cp.craftwork" type="richText" />
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.introduction") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              <raw-html :content="cp.introduction" />
            </td>
          </tr>
        </table>
        <!-- <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
        <div>{{ $t("product.unit") }}：{{ cp.unit }}</div>
        <div v-if="cp.categoryName != null">
          {{ $t("product.category") }}：{{ cp.categoryName }}
        </div>
        <div v-if="cp.productNoAlias != null">
          {{ $t("product.productNoAlias") }}：{{ cp.productNoAlias }}
        </div>
        <div v-if="cp.brand != null">
          {{ $t("product.brand") }}：{{ cp.brand }}
        </div>
        <div v-if="cp.craftwork != null">
          {{ $t("product.craftwork") }}：<raw-html
            :content="cp.craftwork"
            type="richText"
          />
        </div>
        <div v-if="cp.introduction != null">
          {{ $t("product.introduction") }}：<raw-html
            :content="cp.introduction"
          />
        </div> -->
      </div>
    </div>

    <el-dialog
      :title="$t('action.printTag')"
      :close-on-click-modal="false"
      :visible.sync="printSelectColorSizeDF"
      width="60%"
    >
      <el-form ref="printSelectColorSizeForm" label-width="50px">
        <fieldset class="mgb15" v-if="colorsJiaoji.length != 0">
          <legend>
            {{ $t("product.color") }}
            <el-checkbox
              class="mgl10"
              v-model="checkAllColors"
              :indeterminate="isIndeterminateColors"
              @change="handleCheckAllColorsChange"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
            <el-input
              v-model.trim="searchColorsJiaojiName"
              :placeholder="$t('rules.required', [$t('text.name')])"
              style="width: 250px"
              class="mgl5"
              clearable
              size="mini"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchColorsJiaoji"
              />
            </el-input>
          </legend>
          <el-checkbox-group
            size="small"
            v-model="checkedColors"
            @change="handleCheckedColorsChange"
          >
            <el-checkbox
              v-for="color of colorsJiaojiFilter"
              :key="color"
              :label="color"
              style="width: 100px"
              class="mgb10"
            >
              <raw-html-limit-number :content="color" :number="7" />
            </el-checkbox>
          </el-checkbox-group>
        </fieldset>
        <fieldset class="mgb15" v-if="sizesJiaoji.length != 0">
          <legend>
            {{ $t("product.size") }}
            <el-checkbox
              v-model="checkAllSizes"
              :indeterminate="isIndeterminateSizes"
              class="mgl10"
              @change="handleCheckAllSizesChange"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
            <el-input
              v-model.trim="searchSizesJiaojiName"
              :placeholder="$t('rules.required', [$t('text.name')])"
              style="width: 250px"
              class="mgl5"
              clearable
              size="mini"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchSizesJiaoji"
              />
            </el-input>
          </legend>
          <el-checkbox-group
            size="small"
            v-model="checkedSizes"
            @change="handleCheckedSizesChange"
          >
            <el-checkbox
              v-for="size of sizesJiaojiFilter"
              :key="size"
              :label="size"
              style="width: 100px"
            >
              <raw-html-limit-number :content="size" :number="7" />
            </el-checkbox>
          </el-checkbox-group>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <template v-if="printType == 'normal'">
          <el-button
            type="primary"
            plain
            :loading="printSelectColorSizeDFDoing"
            size="small"
            @click="printSelectColorSizeSubmit('normalNoPrice')"
            >{{ $t("text.submit") }}(不带价格)</el-button
          >
          <el-button
            type="success"
            plain
            :loading="printSelectColorSizeDFDoing"
            size="small"
            @click="printSelectColorSizeSubmit('normalPrice')"
            >{{ $t("text.submit") }}(带价格)</el-button
          >
        </template>
        <template v-if="printType == 'custom'">
          <el-button
            type="primary"
            plain
            :loading="printSelectColorSizeDFDoing"
            size="small"
            @click="printSelectColorSizeSubmit('custom')"
            >{{ $t("text.submit") }}</el-button
          >
        </template>

        <el-button size="small" @click="printSelectColorSizeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :uuid="currentRowUuid" @updateInfo="showRowClose" />
    </drawer>

    <drawer
      :title="$t('product.phase')"
      :visible.sync="showPhaseDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-phase :uuid="currentRowUuid" />
    </drawer>
    <drawer
      :title="$t('product.material')"
      :visible.sync="showMaterialDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-material :uuid="currentRowUuid" @updateInfo="showMaterialClose" />
    </drawer>

    <drawer
      :title="$t('text.edit')"
      :visible.sync="showEditDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit :uuid="currentRowUuid" @updateInfo="editRowClose" />
    </drawer>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import Qrcode from "@chenfengyuan/vue-qrcode";
import QRCode from "qrcode";
import PagerConfig from "@/config/pager.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Currency from "@/components/Currency";
import RawHtml from "@/components/RawHtml";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Product from "@/api/product.js";
import Category from "@/api/category.js";
import Label from "@/api/label.js";
import PrintTemplate from "@/api/printTemplate.js";
import Supplier from "@/api/supplier.js";
import Inquiry from "@/api/inquiry.js";
import Brand from "@/api/brand";
import Material from "@/api/material.js";
import Show from "./show.vue";
import ShowPhase from "./showPhase.vue";
import ShowMaterial from "./showMaterial.vue";
import Edit from "./edit.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Qrcode,
    QRCode,
    Show,
    ShowPhase,
    ShowMaterial,
    Edit,
    RawHtmlLimitNumber,
    Currency,
    RawHtml,
  },
  data() {
    return {
      Util: Util,
      // 设置只能选择今天以后
      pickerTodayAfterTime: {
        pickerTodayAfterTime(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pagerConfig: PagerConfig.product,
      pager: {
        currentPage: 1,
        pageSize: PagerConfig.product.defaultPageSize,
        total: 0,
      },
      narrows: [
        [
          {
            label: this.$t("product.verifyInfo"),
            items: [
              {
                label: this.$t("verifyInfos.yes"),
                key: "yes",
                condition: { verify: "yes" },
              },
              {
                label: this.$t("verifyInfos.no"),
                key: "no",
                condition: { verify: "no" },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("product.productNoRepeat"),
                key: "productNoRepeat",
                condition: {
                  special: "productNoRepeat",
                  sortBy: "products_productNo",
                },
                numberFun: Product.repeatCount,
                emitNames: ["productUpdate", "productDelete"],
              },
            ],
          },
        ],
      ],

      searchForm: {
        productNo: null,
        supplierProductNo: null,
        materialId: null,
        labels: [],
      },
      materials: [],
      serialNosLoading: false,
      sorter: {
        sortBy: "products_refreshAt",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "products_productNo",
      },

      Util: Util,
      cardPattern: true,
      checkedProducts: [],
      checkAllDF: false,
      //
      printTemplatesProduct: [],
      // 询价
      inquiryType: "single",
      inquirySuppliers: [], //有简赢账户的
      inquiryDF: false,
      inquiryObj: {
        type: "private",
        serialNo: null,
        images: null,
        productNo: null,
        expirateAt: null,
        quantity: null,
        inquiryItems: [],
        explain: null,
      },
      isIndeterminateSuppliersDF: false,
      checkedSuppliers: [],
      checkAllSuppliersDF: false,
      inquirySubmitDoing: false,
      // 审核
      verifyBatchDoing: false,
      // 标签
      batchAddLabelDF: false,
      labels: [],
      labelGroups: [],
      batchAddLabelSubmitDoing: false,
      checkedLabelIds: [],
      // 打印
      colorsJiaoji: [],
      sizesJiaoji: [],
      printSelectColorSizeDF: false,
      printSelectColorSizeDFDoing: false,
      combinationProducts: [],
      // 颜色
      isIndeterminateColors: false,
      checkedColors: [],
      checkAllColors: false,
      searchColorsJiaojiName: null,
      colorsJiaojiFilter: [],
      // 尺码
      isIndeterminateSizes: false,
      checkedSizes: [],
      checkAllSizes: false,
      searchSizesJiaojiName: null,
      sizesJiaojiFilter: [],
      //
      printType: "normal",
      printCustomTemplateDatas: [],
      printCustomTemplateCmd: null,

      //
      currentRowUuid: null,
      currentRowIdx: null,
      showDF: false,
      showPhaseDF: false,
      showMaterialDF: false,
      showEditDF: false,
    };
  },
  created() {
    const self = this;
    if (
      localStorage.getItem("cardPattern") &&
      localStorage.getItem("cardPattern") != null
    ) {
      self.cardPattern = JSON.parse(localStorage.getItem("cardPattern"));
    }
    axios
      .all([
        Category.findByTenantId(),
        Label.findByTenantId(),
        Label.findAllSortByGroup(),
        Brand.findByTenantId(),
        PrintTemplate.findByType({ type: "product" }),
      ])
      .then(
        axios.spread(function (
          categories,
          labels,
          labelGroups,
          brands,
          printTemplatesProduct
        ) {
          if (categories.status === 200) {
            if (categories.data.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("product.category"),
                  items: categories.data.map((category) => {
                    return {
                      label: category.name,
                      key: category.id,
                      condition: { categoryId: category.id },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          if (labels.status === 200) {
            self.labels = labels.data;
          } else {
            self.sysError();
          }
          if (labelGroups.status === 200) {
            self.labelGroups = labelGroups.data;
            for (let labelGroup of self.labelGroups) {
              if (labelGroup.name != "--") {
                Vue.set(labelGroup, "radio", null);
              } else {
                Vue.set(labelGroup, "radio", []);
              }
            }
          } else {
            self.sysError();
          }

          if (brands.status === 200) {
            self.narrows.push([
              // {
              //   label: self.$t("product.label"),
              //   items: labels.data.map((label) => {
              //     return {
              //       label: label.name,
              //       key: label.name,
              //       condition: { label: label.name },
              //     };
              //   }),
              // },
              {
                label: self.$t("product.brand"),
                items: brands.data.map((brand) => {
                  return {
                    label: brand.name,
                    key: brand.name,
                    condition: { brand: brand.name },
                  };
                }),
              },
            ]);
          } else {
            self.sysError();
          }
          if (printTemplatesProduct.status === 200) {
            self.printTemplatesProduct = printTemplatesProduct.data;
          } else {
            self.sysError();
          }

          if (
            self.Permit.extendModels().includes("mms") &&
            self.Permit.canActionsChargeEdition("mmsProductView")
          ) {
            self.narrows[0].push({
              label: self.$t("product.ingredientInfo"),
              items: Product.productMixStates.map((productMixState) => {
                return {
                  label: self.$t("productMixStates." + productMixState),
                  key: productMixState,
                  condition: { mixState: productMixState },
                };
              }),
            });
          }
          if (
            self.Permit.extendModels().includes("mes") &&
            self.Permit.canActionsChargeEdition("mesProductView")
          ) {
            self.narrows[0].push({
              label: self.$t("product.matchPhaseInfo"),
              items: [
                {
                  label: self.$t("matchPhaseInfos.no"),
                  key: "matchPhaseNo",
                  condition: { match: "no" },
                },
                {
                  label: self.$t("matchPhaseInfos.yes"),
                  key: "matchPhaseYes",
                  condition: { match: "yes" },
                },
              ],
            });
          }
        })
      );
  },
  methods: {
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.serialNosLoading = true;
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          if (self.materials.length !== 0) {
            for (const material of self.materials) {
              Vue.set(
                material,
                "serialNoName",
                material.serialNo + "(" + material.name + ")"
              );
            }
          }
          self.serialNosLoading = false;
        }
      );
    },
    handleSelectSerialNo() {
      const self = this;
      // const item = self.materials.find(
      //   (p) => p.serialNo === self.formObj.items[idx].serialNo
      // );
    },
    //
    setSelected() {
      this.setSelectedQty();
      this.checkedProducts =
        (this.$refs.recordsTable &&
          this.$refs.recordsTable.getCheckboxRecords()) ||
        [];
    },
    //
    editRow(row, rowIndex) {
      this.currentRowUuid = row.uuid;
      this.currentRowIdx = rowIndex;
      this.showEditDF = true;
    },
    editRowClose(data) {
      // this.records[this.currentRowIdx] = data;
      this.loadData();
      this.$eventHub.$emit("productUpdate");
      this.showEditDF = false;
    },
    showMaterial(row, rowIndex) {
      this.currentRowUuid = row.uuid;
      this.currentRowIdx = rowIndex;
      this.showMaterialDF = true;
    },
    showMaterialClose(data) {
      this.records[this.currentRowIdx].mixState = data;
      this.showMaterialDF = false;
    },
    showPhase(row) {
      this.currentRowUuid = row.uuid;
      this.showPhaseDF = true;
    },
    showRow(row, rowIndex) {
      this.currentRowUuid = row.uuid;
      this.currentRowIdx = rowIndex;
      this.showDF = true;
    },
    showRowClose() {
      this.records[this.currentRowIdx].verifyAt = Date.now();
      this.showDF = false;
    },
    printBaseInfo() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.print("printBaseInfoDiv");
    },
    printTag(cmd) {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      if (["printQrCodesDiv", "printQrCodesNoPriceDiv"].includes(cmd)) {
        self.printType = "normal";
        self.print(cmd);
        return;
      }

      if (
        self.checkedProducts.length == 1 &&
        self.checkedProducts[0].colors.length == 0 &&
        self.checkedProducts[0].sizes.length == 0
      ) {
        self.$message({
          message: this.$t("prompt.noColorSize"),
          type: "warning",
        });
        return;
      }
      const colorsArr = self.checkedProducts.map((p) => p.colors);
      const sizesArr = self.checkedProducts.map((p) => p.sizes);
      self.colorsJiaoji = self.jiaoji(colorsArr);
      self.colorsJiaojiFilter = self.colorsJiaoji;
      self.sizesJiaoji = self.jiaoji(sizesArr);
      self.sizesJiaojiFilter = self.sizesJiaoji;

      if (cmd === "printSelectColorSizeDiv") {
        self.printType = "normal";
        if (self.colorsJiaoji.length === 0 && self.sizesJiaoji.length === 0) {
          this.$message({
            message: this.$t("prompt.noColorSizeIntersection"),
            type: "warning",
          });
          return;
        }
        self.printSelectColorSizeDF = true;
        self.checkedSizes = [];
        self.checkedColors = [];
        self.searchColorsJiaojiName = null;
        self.searchSizesJiaojiName = null;
        return;
      }
      self.printType = "custom";
      let existColorDF = cmd.content.indexOf("${颜色}") != -1;
      let existSizeDF = cmd.content.indexOf("${规格}") != -1;
      // console.log("===22", existColorDF, existSizeDF);
      if (!existColorDF && !existSizeDF) {
        self.printCustomTemplateDatas = self.checkedProducts;
        self.printCustomTemplateSubmit(cmd);
      } else {
        if (self.colorsJiaoji.length === 0 && self.sizesJiaoji.length === 0) {
          this.$message({
            message: this.$t("prompt.noColorSizeIntersection"),
            type: "warning",
          });
          return;
        }
        self.printSelectColorSizeDF = true;
        self.checkedSizes = [];
        self.checkedColors = [];
        self.searchColorsJiaojiName = null;
        self.searchSizesJiaojiName = null;
        self.printCustomTemplateCmd = cmd;
        return;
      }

      //
    },
    jiaoji(arrs) {
      let jiaoji = arrs.shift();
      for (const arr of arrs) {
        jiaoji = Util.intersection(jiaoji, arr);
      }
      return jiaoji;
    },
    // 颜色
    handleCheckAllColorsChange(val) {
      this.checkedColors = val ? this.colorsJiaojiFilter : [];
      this.checkedColorSize();
    },
    handleCheckedColorsChange(value) {
      const checkedCount = value.length;
      this.checkAllColors = checkedCount === this.colorsJiaojiFilter.length;
      this.isIndeterminateColors =
        checkedCount > 0 && checkedCount < this.colorsJiaojiFilter.length;
      this.checkedColorSize();
    },
    searchColorsJiaoji() {
      this.checkedColors = [];
      this.checkAllColors = false;
      this.isIndeterminateColors = false;
      if (
        this.searchColorsJiaojiName == null ||
        this.searchColorsJiaojiName == ""
      ) {
        this.colorsJiaojiFilter = this.colorsJiaoji;
        return;
      }
      this.colorsJiaojiFilter = this.colorsJiaoji.filter(
        (c) => c.indexOf(this.searchColorsJiaojiName) != -1
      );
    },
    // 尺码
    handleCheckAllSizesChange(val) {
      this.checkedSizes = val ? this.sizesJiaojiFilter : [];
      this.checkedColorSize();
    },
    handleCheckedSizesChange(value) {
      const checkedCount = value.length;
      this.checkAllSizes = checkedCount === this.sizesJiaojiFilter.length;
      this.isIndeterminateSizes =
        checkedCount > 0 && checkedCount < this.sizesJiaojiFilter.length;
      this.checkedColorSize();
    },
    searchSizesJiaoji() {
      this.checkedSizes = [];
      this.checkAllSizes = false;
      this.isIndeterminateSizes = false;
      if (
        this.searchSizesJiaojiName == null ||
        this.searchSizesJiaojiName == ""
      ) {
        this.sizesJiaojiFilter = this.sizesJiaoji;
        return;
      }
      this.sizesJiaojiFilter = this.sizesJiaoji.filter(
        (c) => c.indexOf(this.searchSizesJiaojiName) != -1
      );
    },

    checkedColorSize() {
      const self = this;
      self.combinationProducts = [];
      for (const product of self.checkedProducts) {
        //
        if (self.checkedColors.length !== 0 && self.checkedSizes.length !== 0) {
          for (const color of self.checkedColors) {
            for (const size of self.checkedSizes) {
              let temProduct = JSON.parse(JSON.stringify(product));
              const productSizePriceObj = product.productSizePrices.find(
                (p) => p.size === size
              );
              Vue.set(temProduct, "color", color);
              Vue.set(temProduct, "size", size);
              Vue.set(
                temProduct,
                "salesPrice",
                productSizePriceObj != null &&
                  productSizePriceObj.salesPrice != null
                  ? productSizePriceObj.salesPrice
                  : product.salesPrice
              );
              self.combinationProducts.push(temProduct);
            }
          }
        }
        //
        if (self.checkedColors.length !== 0 && self.checkedSizes.length === 0) {
          for (const color of self.checkedColors) {
            let temProduct = JSON.parse(JSON.stringify(product));
            Vue.set(temProduct, "color", color);
            Vue.set(temProduct, "size", null);
            Vue.set(temProduct, "salesPrice", product.salesPrice);
            self.combinationProducts.push(temProduct);
          }
        }
        //
        if (self.checkedColors.length === 0 && self.checkedSizes.length !== 0) {
          for (const size of self.checkedSizes) {
            let temProduct = JSON.parse(JSON.stringify(product));
            const productSizePriceObj = product.productSizePrices.find(
              (p) => p.size === size
            );
            Vue.set(temProduct, "color", null);
            Vue.set(temProduct, "size", size);
            Vue.set(
              temProduct,
              "salesPrice",
              productSizePriceObj != null &&
                productSizePriceObj.salesPrice != null
                ? productSizePriceObj.salesPrice
                : product.salesPrice
            );
            self.combinationProducts.push(temProduct);
          }
        }
      }
    },
    printSelectColorSizeSubmit(type) {
      const self = this;
      this.printSelectColorSizeDF = false;
      this.checkedProducts = [];
      if (type == "normalNoPrice") {
        this.print("printSelectColorSizeDivNoPrice");
      }
      if (type == "normalPrice") {
        this.print("printSelectColorSizeDiv");
      }
      if (type == "custom") {
        self.printCustomTemplateDatas = self.combinationProducts;
        self.printCustomTemplateSubmit(self.printCustomTemplateCmd);
      }
    },
    async printCustomTemplateSubmit(cmd) {
      const self = this;
      let customPrintContent = "";
      let i = 0;
      for (const checkedProduct of self.printCustomTemplateDatas) {
        let customPrintContentProduct = "";
        if (i == 0) {
          customPrintContentProduct = "<div>" + cmd.content;
        } else {
          customPrintContentProduct =
            "<div style='page-break-before: always;'>" + cmd.content;
        }
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${货号}/g,
          checkedProduct.productNo
        );

        let qrRes = await QRCode.toDataURL(
          self.qrCodesCustomPrint(checkedProduct)
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${货号二维码}/g,
          "<img src=" + qrRes + " style='width: 100px'/>"
        );

        customPrintContentProduct = customPrintContentProduct.replace(
          /\${单位}/g,
          checkedProduct.unit || ""
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${分类}/g,
          checkedProduct.categoryName || ""
        );

        customPrintContentProduct = customPrintContentProduct.replace(
          /\${品牌}/g,
          checkedProduct.brand || ""
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${售价}/g,
          "¥" + checkedProduct.salesPrice || ""
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${批发价}/g,
          "¥" + checkedProduct.wholesalePrice || ""
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${主料}/g,
          checkedProduct.mainMaterial || ""
        );
        // customPrintContentProduct = customPrintContentProduct.replace(
        //   /\${颜色}/g,
        //   checkedProduct.colors.join("；")
        // );
        // customPrintContentProduct = customPrintContentProduct.replace(
        //   /\${规格}/g,
        //   checkedProduct.sizes.join("；")
        // );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${颜色}/g,
          checkedProduct.color
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${规格}/g,
          checkedProduct.size
        );
        if (checkedProduct.productSizePrices.length !== 0) {
          let productSizeSalesPrice = "";
          let productSizeWholesalePrice = "";
          for (const productSizePrice of checkedProduct.productSizePrices) {
            productSizeSalesPrice =
              productSizeSalesPrice +
              productSizePrice.size +
              "：¥" +
              productSizePrice.salesPrice +
              " / ";
            productSizeWholesalePrice =
              productSizeWholesalePrice +
              productSizePrice.size +
              "：¥" +
              productSizePrice.wholesalePrice +
              " / ";
          }
          customPrintContentProduct = customPrintContentProduct.replace(
            /\${售价带规格}/g,
            productSizeSalesPrice
          );
          customPrintContentProduct = customPrintContentProduct.replace(
            /\${批发价带规格}/g,
            productSizeWholesalePrice
          );
        } else {
          customPrintContentProduct = customPrintContentProduct.replace(
            /\${售价带规格}/g,
            "¥" + checkedProduct.salesPrice || ""
          );
          customPrintContentProduct = customPrintContentProduct.replace(
            /\${批发价带规格}/g,
            "¥" + checkedProduct.wholesalePrice || ""
          );
        }
        customPrintContent =
          customPrintContent + customPrintContentProduct + "</div>";
        i++;
      }

      window.document.getElementById("printCustomTemplate").innerHTML =
        customPrintContent;
      self.print("printCustomTemplateDiv");
    },
    print(type) {
      this.printFunction(type);
    },
    qrCodes(cp) {
      return cp.productNo;
      // return `${cp.productNo}|||product|`;
      // return encodeURI(
      //   "http://gzh.jianyingkeji.com/professional-products/" +
      //     this.Permit.currentUser().phone +
      //     "/" +
      //     cp.uuid +
      //     "?productNo=" +
      //     cp.productNo +
      //     "&color=" +
      //     cp.color +
      //     "&size=" +
      //     cp.size
      // );
    },
    qrCodesCustomPrint(cp) {
      return cp.productNo + "|" + cp.color + "|" + cp.size + "|product|";
    },
    batchUpdateSupplierPriceToCost(type) {
      const self = this;
      if (type.indexOf("checked") !== -1) {
        if (!self.downloadChecked(self.checkedProducts)) {
          return;
        }
        const data = {
          ids: self.checkedProducts.map((c) => c.id),
          type: "checked",
        };
        if (confirm(self.$t("action.updateSupplierPriceToCost"))) {
          self.batchUpdateSupplierPriceToCostFun(data);
        }
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        Vue.set(data, "type", "search");
        if (confirm(self.$t("action.updateSupplierPriceToCost"))) {
          self.batchUpdateSupplierPriceToCostFun(data);
        }
      }
    },
    batchUpdateSupplierPriceToCostFun(data) {
      const self = this;
      Product.batchUpdateSupplierPriceToCost(data).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.updateSuccess"),
            type: "success",
          });
          self.checkedProducts = [];
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 下载
    download(type) {
      const self = this;
      if (type.indexOf("checked") !== -1) {
        if (!self.downloadChecked(self.checkedProducts)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.checkedProducts.map((c) => c.id),
          exportWithImg: type.indexOf("WithImg") !== -1,
        };
        self.downloadData(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        Vue.set(data, "exportWithImg", type.indexOf("WithImg") !== -1);
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Product.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.checkedProducts = [];
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //下载工序
    downloadPhases(type) {
      const self = this;
      if (type.indexOf("checked") !== -1) {
        if (!self.downloadChecked(self.checkedProducts)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.checkedProducts.map((c) => c.id),
        };
        self.downloadDataPhases(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadDataPhases(data);
      }
    },
    downloadDataPhases(data) {
      const self = this;
      Product.exportExcelPhases(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.checkedProducts = [];
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    // 批量添加标签
    batchAddLabel() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      self.checkedLabelIds = [];
      self.batchAddLabelDF = true;
    },
    batchAddLabelSubmit() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        this.$message({
          message: this.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      let labelIds = [];
      for (const labelGroup of self.labelGroups) {
        if (labelGroup.name != "--") {
          if (labelGroup.radio != null && labelGroup.radio != "") {
            labelIds.push(labelGroup.radio);
          }
        } else {
          labelIds = labelIds.concat(labelGroup.radio);
        }
      }
      const data = self.checkedProducts.map((c) => {
        return {
          id: c.id,
          labelIds: labelIds,
        };
      });
      self.batchAddLabelSubmitDoing = true;
      Product.batchInsertLabels(data).then(function (res) {
        self.batchAddLabelSubmitDoing = false;
        self.batchAddLabelDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.checkedProducts = [];
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    // 审核
    verifyBatch() {
      const self = this;
      const noVerifyProducts = this.checkedProducts.filter(
        (c) => c.verifyAt == null
      );
      if (noVerifyProducts.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneUnVerifyData"),
          type: "warning",
        });
        return;
      }
      // const mustFillProducts = noVerifyProducts.filter(
      //   (c) => c.costPrice !== null || c.salesPrice !== null
      // );
      // if (mustFillProducts.length === 0) {
      //   self.$message({
      //     message: this.$t("prompt.atLeastMustFillProductsData"),
      //     type: "warning",
      //   });
      //   return;
      // }
      const noVerifyIds = noVerifyProducts.map((c) => c.id);
      self.verifyBatchDoing = false;
      Product.verifyBatch(noVerifyIds).then(function (res) {
        self.verifyBatchDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.checkedProducts = [];
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 询价
    inquiry(row, type) {
      const self = this;
      self.inquiryType = type;
      if (type == "batch") {
        const canInqueryProducts = this.checkedProducts.filter(
          (c) => c.verifyAt !== null
        );
        if (canInqueryProducts.length == 0) {
          self.$message({
            message: self.$t("prompt.notExistCanInqueryProduct"),
            type: "warning",
          });
          return;
        }
      }
      self.inquiryObj.type = "private";
      self.inquiryObj.serialNo = null;
      self.inquiryObj.images = row.images;
      self.inquiryObj.productNo = row.productNo;
      self.inquiryObj.expirateAt = null;
      self.inquiryObj.explain = null;
      self.inquiryObj.inquiryItems = [];
      self.inquiryObj.quantity = 1;
      self.checkedSuppliers = [];
      self.getSuppliers();
      self.inquirySubmitDoing = false;
      self.inquiryDF = true;
    },
    getSuppliers() {
      const self = this;
      Supplier.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.inquirySuppliers = res.data.filter(
            (s) => s.sourceTenantId != null
          );
        } else {
          self.sysError();
        }
      });
    },
    checkAllSuppliers(val) {
      this.checkedSuppliers = val ? this.inquirySuppliers : [];
    },
    checkSupplier(value) {
      const checkedCount = value.length;
      this.checkAllSuppliersDF = checkedCount === this.inquirySuppliers.length;
      this.isIndeterminateSuppliersDF =
        checkedCount > 0 && checkedCount < this.inquirySuppliers.length;
    },
    inquirySubmit() {
      const self = this;
      self.$refs.inquiryObjForm.validate((valid) => {
        if (valid) {
          if (
            self.inquiryObj.type === "private" &&
            self.checkedSuppliers.length === 0
          ) {
            self.$message({
              message: self.$t("prompt.atLeastOneSupplier"),
              type: "warning",
            });
            return;
          }
          self.inquiryObj.inquiryItems = self.checkedSuppliers.map((c) => {
            return { supplierId: c.id, supplierTenantId: c.sourceTenantId };
          });
          self.inquiryObj.expirateAt = Util.formatDate(
            self.inquiryObj.expirateAt
          );
          self.inquirySubmitDoing = true;
          let datas = [];
          if (self.inquiryType === "single") {
            self.inquiryObj.serialNo = Util.serialNo();
            datas = [self.inquiryObj];
          } else {
            const canInqueryProducts = this.checkedProducts.filter(
              (c) => c.verifyAt !== null
            );
            datas = canInqueryProducts.map((product) => {
              return {
                type: self.inquiryObj.type,
                serialNo: Util.serialNo(),
                images: product.images,
                productNo: product.productNo,
                expirateAt: self.inquiryObj.expirateAt,
                quantity: 1,
                inquiryItems: self.inquiryObj.inquiryItems,
                explain: self.inquiryObj.explain,
              };
            });
          }
          Inquiry.insertBatch(datas).then(function (res) {
            self.inquirySubmitDoing = false;
            self.inquiryDF = false;
            self.checkedProducts = [];
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.inquirySuccess"),
                type: "success",
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 刷新
    refreshRow(row) {
      const self = this;
      Product.refresh(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.refreshSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 批量删除
    batchDelete() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneValidData"),
          type: "warning",
        });
        return;
      }
      // console.log("===", this.checkedProducts);
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Product.batchDelete(self.checkedProducts.map((c) => c.id)).then(
          function (res) {
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.delSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          }
        );
      }
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Product.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("productDelete");
          } else {
            self.sysError();
          }
        });
      }
    },

    checkedProduct() {
      this.selectRecordQty = this.checkedProducts.length;
    },

    checkAll() {
      if (this.checkAllDF === true) {
        this.checkedProducts = this.records;
      } else {
        this.checkedProducts = [];
      }
      this.selectRecordQty = this.checkedProducts.length;
    },

    cardPatternChange() {
      localStorage.setItem("cardPattern", this.cardPattern);
      this.checkedProducts = [];
      this.checkAllDF = false;
      this.selectRecordQty = this.checkedProducts.length;
    },
    dataProvider(params) {
      return Product.search(params);
    },
  },
};
</script>
<style scoped>
.image-div {
  height: 200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  text-align: center;
  /* background: rgb(245, 240, 240); */
}
.product-checkbox-div {
  position: absolute;
  width: 16%;
}
.product-label-div {
  position: absolute;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.product-label {
  background: #d83732;
  border: 1px solid #d83732;
  margin: 0 0 1px 0;
  text-align: left;
  padding: 2px 6px 2px 2px;
  font-size: 12px;
  display: inline-block !important;
  display: inline;
  border-bottom-right-radius: 40px;
  border-top-right-radius: 40px;
  color: #fff;
  opacity: 0.8;
  /* width: auto; */
  /* max-width: 80px; */
  /* overflow: hidden; */
}
</style>